import { EVENT_ENVIRONMENT } from './config';

export const KAFKA_TOPICS = {
    EXPERIENCE_NAVIGATION: `${ EVENT_ENVIRONMENT }-experience-navigation`
};